import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withTranslation } from 'react-i18next';
import './OrderContainer.css'
import EmailTemplateWithButtons from '../../Components/EmailTemplateWithButtons'
import orderActions from '../../Actions/orderActions'
import commonActions from '../../Actions/commonActions'
import customerActions from '../../Actions/customerActions'
import { useParams, useNavigate } from 'react-router-dom';
import Grid from '../../Components/Grid/Grid';
import Card from '../../Components/Card/Card';
import orderRocket from '../../Images/milestone_rocket.svg'
import TextInput from '../../Components/TextInput';
import customerRoutes from '../../Constants/Customer/customerRoutes';

const CUSTOM_ORDER_INFO_TEXT_MARKER = 'data-custom-order-info-text';


function OrderConfirmationContainer({ commonActions, confirmationForm, t, orderActions, customerActions, customer, frontendSettings }) {

    const navigate = useNavigate();
    const { orderId } = useParams()

    useEffect(() => {
        orderActions.getConfirmationFormTemplate(orderId);
    }, [])

    useEffect(() => {
        if (typeof window._sva?.invokeEvent === 'function') {
            window._sva.invokeEvent('CSAT_PlaceOrder');
        } else {
            const onReady = () => window._sva?.invokeEvent('CSAT_PlaceOrder');
            window.addEventListener('SurvicateReady', onReady, { once: true });

            if (!document.getElementById('survicate-script')) {
                const workspaceKey = frontendSettings?.survicateWorkspaceKey;
                if (workspaceKey) {
                    const script = document.createElement('script');
                    script.id = 'survicate-script';
                    script.src = `https://survey.survicate.com/workspaces/${workspaceKey}/web_surveys.js`;
                    script.async = true;
                    document.head.appendChild(script);
                }
            }

            return () => window.removeEventListener('SurvicateReady', onReady);
        }
    }, [])

    const navigateAfterAction = () => {
        return () => navigate(customerRoutes.customer(customer.pathId))
    }

    const onFieldChange = (field, value) => {
        commonActions.changeMultiFormField(confirmationForm.id, field, value)
    }

    const onCustomOrderInfoTextChange = (value) => {
        commonActions.changeMultiFormField(confirmationForm.id, 'customOrderInfoText', value)
    }

    const onSaveClick = () => {
        customerActions.sendAdminForm(confirmationForm, navigateAfterAction(), "Order Confirmation has been sent");
    }

    const onCancelClick = () => {

        commonActions.cancelFormEditing(confirmationForm.id, navigateAfterAction())
    }

    if (!confirmationForm) {
        return null;
    }

    const hasCustomOrderInfoText = confirmationForm.data?.body?.includes(CUSTOM_ORDER_INFO_TEXT_MARKER);

    return (
        <Grid>
            <Grid.Row>
                <Grid.Row.Column width={6}>
                    <Card>
                        <Card.Header>
                            <Card.Header.Title>
                                {t('orderconfirmationcontainer.orderconfirmation')}
                            </Card.Header.Title>
                        </Card.Header>
                        <Card.Content>
                            <EmailTemplateWithButtons data={confirmationForm.data}
                                onChange={onFieldChange.bind(this)}
                                onSaveClick={onSaveClick.bind(this)}
                                onCancelClick={onCancelClick.bind(this)}
                                senderEmails={confirmationForm.data.defaultSenderAddresses}
                                onSenderChange={onFieldChange.bind(this)}
                                hideWarning={true}
                            >
                                {hasCustomOrderInfoText && (
                                    <TextInput
                                        label={t('orderconfirmationcontainer.customorderinfotext')}
                                        placeholder={t('orderconfirmationcontainer.customorderinfotextplaceholder')}
                                        value={confirmationForm.data.customOrderInfoText || ''}
                                        onChange={onCustomOrderInfoTextChange}
                                        multiline
                                    />
                                )}
                            </EmailTemplateWithButtons>
                        </Card.Content>
                    </Card>
                </Grid.Row.Column>
                <Grid.Row.Column>
                    <div className='d-flex justify-content-center h-100'>
                    <img src={orderRocket} alt='en fin raket' width={450}/>
                    </div>
                </Grid.Row.Column>
            </Grid.Row>
        </Grid >
    );
}


function mapStateToProps(state) {
    return {
        confirmationForm: state.CommonReducer.forms && state.CommonReducer.forms.confirmationMail,
        customer: state.CustomerReducer.customer,
        frontendSettings: state.CommonReducer.frontendSettings
    }
}

function mapDispatchToProps(dispatch) {
    return {
        orderActions: bindActionCreators(orderActions, dispatch),
        commonActions: bindActionCreators(commonActions, dispatch),
        customerActions: bindActionCreators(customerActions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(OrderConfirmationContainer));